<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="spreadsheet">
    <vx-card :title="'Novo Arquivo.xlsx'">
      <ejs-spreadsheet :height="windowHeight - 300" :openUrl="'https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/open'" :allowOpen="true" :allowSave="true" :saveUrl="saveUrl" :beforeOpen="beforeOpen"></ejs-spreadsheet>
    </vx-card>
  </div>
</template>

<script>

// import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet';

export default {
  data () {
    return {
      saveUrl: 'https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/save',
      windowHeight: window.innerHeight,
      scrollSettings: {
        height: 800
      }
    }
  },
  components: {
    // SpreadsheetPlugin
  },
  mounted () {
    // this.$vs.loading({type: 'default'})

    document.title = `${document.title.split(' | ')[0]  } | Dashboard`

    // setTimeout(() => {
    //   document.querySelector('.e-sheet-panel').style.maxHeight = screen.height - 500 + 'px'
    //   document.querySelector('.e-sheet-panel').style.height = screen.height - 500 + 'px'
    //   this.$vs.loading.close()
    // }, 300)
  },
  created () {
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
    },
    beforeOpen(args) {
      // console.log(args)
    }
  }
}
</script>
<style>

/* @import '../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-grids/styles/material.css';
@import "../../node_modules/@syncfusion/ej2-vue-spreadsheet/styles/material.css"; */

.e-sheet-panel {
  /* max-height: 930px!important;
  height: 500px!important; */
}
</style>
